import angular from 'angular';

import DealerChat from '../dealerChat/index';
import SellerData from '../sellerData';

import component from './typModal.component';
import controller from './typModal.controller';

export default angular.module('app.shared.typModal', [
    'cars.ui.angular',
	DealerChat,
	SellerData,
])

.component('carsTypModal', component)
.controller('typModalController', controller)

.name;
